<div class="flex h-full gap-6">
  <elcia-side-nav [items]="navItems" [activeValue]="activeSection()" (valueChange)="navigate($event)"/>
  <div class="flex-1 h-full">
    <router-outlet/>
  </div>
</div>
